import {
	MessageMappedType,
	MessageModel,
	MessageType,
	ServiceMessageModel,
	WritingModel,
} from 'Pages/chat'

export function isMessageModel(data: MessageMappedType): data is MessageModel {
	return (data as MessageModel)?.meta_info !== undefined
}

export function isServiceMessageModel(data: MessageMappedType): data is ServiceMessageModel {
	return (data as ServiceMessageModel)?.message_type === MessageType.SERVICE
}

export function isWritingModel(data: MessageMappedType): data is WritingModel {
	return (data as ServiceMessageModel)?.message_type === MessageType.WRITING
}
